import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 0;

const slice = createSlice({
  name: '$futureOrderingLimit',
  initialState,
  reducers: {
    setFutureOrderingLimit(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setFutureOrderingLimit } = slice.actions;
export default slice.reducer;
